export default "__VITE_PUBLIC_ASSET__23b136e2__"